export default "__VITE_ASSET__m7bbCMRi__"